import { cn } from '@/shared/lib/utils'
import { RankingUser } from '@/shared/types/user'
import { CosmeticAvatarComposite } from '@/shared/ui/CosmeticAvatarComposite'

interface RankingCardProps {
  rankingUser: RankingUser
  onClick: () => void
  /**
   * Destaca a linha como sendo a do aluno logado ("Você"). Opt-in por prop —
   * as linhas trazem `is_current_user`, mas só o ranking de campanha usa o
   * destaque hoje.
   */
  isCurrentUser?: boolean
}

export const RankingCard = ({
  rankingUser,
  onClick,
  isCurrentUser = false
}: RankingCardProps) => {
  const isMedalist = rankingUser.position <= 3

  return (
    <div
      className={cn('flex items-center px-3 gap-2 cursor-pointer', {
        'border-2 rounded-lg': isMedalist || isCurrentUser,
        'border-[#FF9D00]': rankingUser.position === 1 && !isCurrentUser,
        'border-[#658EE5]': rankingUser.position === 2 && !isCurrentUser,
        'border-[#CE9D8C]': rankingUser.position === 3 && !isCurrentUser,
        'border-primary bg-primary/10': isCurrentUser
      })}
      onClick={onClick}
    >
      <div className="flex items-center gap-2 py-3 grow border-b-2 border-gray-200/70">
        <div className="size-7 flex items-center justify-center shrink-0">
          {rankingUser.position < 4 ? (
            <img
              src={`/icons/medal-${
                ['gold', 'silver', 'bronze'][rankingUser.position - 1]
              }.svg`}
              alt={`Ranking ${rankingUser.position}`}
              className="size-full"
            />
          ) : (
            <span className="text-lg font-bold text-gray-700">
              {rankingUser.position}
            </span>
          )}
        </div>
        <CosmeticAvatarComposite
          avatar={rankingUser.user?.avatar}
          frame={rankingUser.user?.frame}
          background={rankingUser.user?.background}
          size="xs"
          className="shrink-0"
        />
        <span
          className={cn(
            'text-md lg:text-lg font-semibold line-clamp-1',
            isCurrentUser ? 'text-primary' : 'text-black'
          )}
        >
          {isCurrentUser ? 'Você' : rankingUser.user.name}
        </span>
        <span className="ml-auto font-bold text-[#0063E5] text-md lg:text-lg font-sans">
          {rankingUser.points}
        </span>
      </div>
    </div>
  )
}
